/**
 * Lucky bottle cap. The one item that reaches stage 3 of the damage pipeline, which makes it the
 * proof that `equip.damageModifiers` arrives where it is meant to.
 */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { ArmorItem } from '@/sim/items/itemContract';

export const LUCKY_BOTTLE_CAP = {
  id: 'luckyBottleCap',
  kind: 'armor',
  label: 'Lucky bottle cap',
  description:
    'Vensell orange, bent, warm from a pocket. Its owner survived long enough to lose it.',
  rarity: 'exotic',
  weightKg: 0.01,
  stackLimit: 1,
  equip: {
    slots: ['accessory1', 'accessory2', 'accessory3'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [{ source: 'luckyBottleCap', flat: 0, scale: 1.05 }],
  },
} as const satisfies ArmorItem;
